import { createSelector, createStructuredSelector } from 'reselect'
import { identity } from '@lacele/const'
import { session, test, userInfo } from '../App/selector'

const storeTargetTest = () => test.target
const storeTargetSession = () => session.target

export const mapStateToProps = () => {

    const xAuthToken = createSelector(
        identity,
        (state) => userInfo.getXAuthToken(state)
    )

    const mapProps = createStructuredSelector({
        storeTargetTest,
        storeTargetSession,
        xAuthToken,
    })

    return createSelector(
        identity,
        (_, props) => props,
        mapProps
    )
}
